var _rect, _circle, _path, _path2, _path3, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 50 50",
    height: "30px",
    id: "Layer_1",
    viewBox: "0 0 50 50",
    width: "30px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 50,
    width: 50
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#2A6AA9",
    stroke: "#2A6AA9",
    cx: 43,
    cy: 21,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,15V1H10v14",
    fill: "none",
    stroke: "#2A6AA9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40,29v20H10V29H40z",
    fill: "none",
    stroke: "#2A6AA9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10,40H3  c-1.104,0-2-0.896-2-2V17c0-1.104,0.896-2,2-2h44c1.104,0,2,0.896,2,2v21c0,1.104-0.896,2-2,2h-7",
    fill: "none",
    stroke: "#2A6AA9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#2A6AA9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 35,
    x2: 15,
    y1: 35,
    y2: 35
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#2A6AA9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 31,
    x2: 15,
    y1: 39,
    y2: 39
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#2A6AA9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 35,
    x2: 15,
    y1: 43,
    y2: 43
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.0e9a10e80e4ff27de5067f2c88a8c136.svg";
export { ForwardRef as ReactComponent };